import { addPhoneHyphens } from './form-utils';
export var searchByMenuItems = function (setValue) { return [
    {
        name: 'Item Description',
        value: 'itemDescription',
        placeholder: 'Beginning with...',
        options: {
            minLength: {
                value: 1,
                message: 'Please enter an item description.',
            },
            required: true,
        },
        errorMessages: {
            minLength: 'Please enter an item description.',
        },
    },
    {
        name: 'PO/Job Name',
        value: 'POJobName',
        placeholder: 'Beginning with...',
        options: {},
    },
    {
        name: 'Buyer Name',
        value: 'buyerName',
        placeholder: 'Enter First Name or Last Name',
    },
    {
        name: 'Buyer ID',
        value: 'buyerId',
        placeholder: 'Enter 5-digit Buyer ID',
        options: { maxLength: 5, pattern: /\d/g },
        errorMessages: {
            maxLength: 'Please enter a 5 digit number.',
            pattern: 'Please use only numerical characters',
        },
    },
    {
        name: 'Store Number',
        value: 'storeNumber',
        placeholder: '----',
        options: { maxLength: 4, pattern: /\d/g },
        errorMessages: {
            maxLength: 'Please enter 4 digits.',
            pattern: 'Please use only numerical characters',
        },
    },
    {
        name: 'Order Origin',
        value: 'storeName',
        placeholder: 'Containing...',
        options: { minLength: 4, maxLength: 32 },
        errorMessages: {
            minLength: 'Please enter a value between 4 and 32 characters.',
            maxLength: 'Please enter a value between 4 and 32 characters.',
        },
    },
    {
        name: 'SKU Number',
        value: 'SKUNumber',
        placeholder: '',
        options: {
            minLength: {
                value: 1,
                message: 'Please enter a valid SKU number.',
            },
            maxLength: 45,
        },
        errorMessages: {
            minLength: 'Please enter a valid SKU number.',
            maxLength: 'Please enter a valid SKU number.',
        },
    },
    {
        name: 'Department Number',
        value: 'departmentNumber',
        placeholder: '',
        options: {
            minLength: {
                value: 1,
                message: 'Please enter a valid 2 digit department number.',
            },
            maxLength: 2,
            pattern: /\d/g,
        },
        errorMessages: {
            minLength: 'Please enter a valid 2 digit department number.',
            maxLength: 'Please enter a valid 2 digit department number.',
            pattern: 'Please enter a valid 2 digit department number.',
        },
    },
    {
        name: 'Total Amount',
        value: 'totalAmount',
        placeholder: 'Exact amount with cents',
        options: {
            minLength: {
                value: 1,
                message: 'Please enter a valid total amount.',
            },
            pattern: /^(?!.*#)[+-]?\$?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{1,2})?$/g,
            validate: function (value) { return value <= 999999.99; },
        },
        errorMessages: {
            minLength: 'Please enter a valid total amount.',
            pattern: 'Please enter a valid total amount.',
            validate: 'Please enter a total less than $999,999.99.',
        },
    },
    {
        name: 'Order Number',
        value: 'orderNumber',
        placeholder: 'Beginning with W, H or C',
        options: { pattern: /^[WHCwhc]\w+?[\d-]+/ },
        errorMessages: {
            pattern: 'Please enter a valid order number.',
        },
    },
    {
        name: 'Credit Card (Last 4 Digits)',
        value: 'creditDebitCard',
        placeholder: '----',
        options: { maxLength: 4, pattern: /\d/g },
        errorMessages: {
            maxLength: 'Please enter a 4 digit number.',
            pattern: 'Please enter only numerical characters',
        },
    },
    {
        name: 'Reloadable Card (Digits 13-16)',
        value: 'proXtrareloadableCard',
        placeholder: '----',
        options: { maxLength: 4, pattern: /\d/g },
        errorMessages: {
            maxLength: 'Please enter a 4 digit number.',
            pattern: 'Please enter only numerical characters',
        },
    },
    {
        name: 'Gift Card (Digits 13-16)',
        value: 'giftCard',
        placeholder: '----',
        options: { maxLength: 4, pattern: /\d/g },
        errorMessages: {
            maxLength: 'Please enter a 4 digit number.',
            pattern: 'Please enter only numerical characters',
        },
    },
    {
        name: 'Checking Account (Last 4 Digits)',
        value: 'checkingAccount',
        placeholder: '----',
        options: { maxLength: 4, pattern: /\d/g },
        errorMessages: {
            maxLength: 'Please enter a 4 digit number.',
            pattern: 'Please enter only numerical characters',
        },
    },
    {
        name: 'THD Keytag',
        value: 'THDKeyTag',
        placeholder: '---- ---- ---- ----',
        options: { maxLength: 12, validate: function (value) { return value !== 12; } },
        errorMessages: {
            maxLength: 'Please enter a 12 digit number.',
            validate: 'Please enter a 12 digit number',
        },
    },
    {
        name: 'Phone',
        value: 'phoneNumber',
        placeholder: '--- --- ----',
        options: {
            pattern: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
            onChange: function (event) {
                return setValue('searchByTextfield', addPhoneHyphens(event.target.value.toUpperCase()));
            },
            onBlur: function (event) {
                return setValue('searchByTextfield', addPhoneHyphens(event.target.value.toUpperCase()));
            },
        },
        errorMessages: {
            pattern: 'Please enter a 10 digit number.',
        },
    },
    {
        name: 'PayPal',
        value: 'paypal',
    },
    {
        name: 'Invoice Number',
        value: 'invoiceNumber',
        placeholder: 'Enter Invoice Number',
        options: {
            pattern: /\d/g,
        },
        errorMessages: {
            pattern: 'Please enter a invoice number.',
        },
    },
]; };
export var requestFormatter = {
    itemDescription: function (value) { return [{ itemDescription: value }]; },
    POJobName: function (value) { return [{ POJobName: value }]; },
    storeNumber: function (value) { return [{ storeNumber: value }]; },
    storeName: function (value) { return [{ storeName: value }]; },
    SKUNumber: function (value) { return [{ SKUNumber: value }]; },
    departmentNumber: function (value) { return [{ departmentNumber: value }]; },
    totalAmount: function (value) { return [{ totalAmount: value }]; },
    orderNumber: function (value) { return [{ orderNumber: value }]; },
    creditDebitCard: function (value) { return [{ creditDebitCard: value }]; },
    proXtrareloadableCard: function (value) { return [{ proXtrareloadableCard: value }]; },
    giftCard: function (value) { return [{ giftCard: value }]; },
    checkingAccount: function (value) { return [{ checkingAccount: value }]; },
    THDKeyTag: function (value) { return [{ THDKeyTag: value }]; },
    phoneNumber: function (value) { return [{ phoneNumber: value }]; },
    buyerName: function (value) { return [{ buyerName: value }]; },
    buyerId: function (value) { return [{ buyerId: value }]; },
    paypal: function () { return [{ PayPal: '' }]; },
    invoiceNumber: function (value) { return [{ invoiceNumber: value }]; },
};
